import { render } from "./Bookings.vue?vue&type=template&id=f83d7218&scoped=true"
import script from "./Bookings.vue?vue&type=script&lang=js"
export * from "./Bookings.vue?vue&type=script&lang=js"

import "./Bookings.vue?vue&type=style&index=0&id=f83d7218&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83d7218"]])

export default __exports__